"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiringProcess = HiringProcess;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Api = __importStar(require("api"));
const immer_1 = __importDefault(require("immer"));
const react_intl_1 = require("react-intl");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const elements_1 = require("@src/components/elements");
const account_context_1 = require("@src/context/account-context");
const useAppQuery_1 = require("@src/hooks/useAppQuery");
const queries_1 = require("@src/types/queries");
const HiringProcessColumns_1 = require("./HiringProcessColumns/HiringProcessColumns");
const ApplicationDetailModal_1 = require("./HiringProcessColumns/ApplicationDetailModal");
const HiringProcessColumnsSendMessageModal_1 = require("./HiringProcessColumns/HiringProcessColumnsSendMessageModal");
const admin_context_1 = require("../../admin-context");
const FinishHiringProcessModal_1 = require("./FinishHiringProcessModal");
const ApplicationDetailModal_style_1 = require("./HiringProcessColumns/ApplicationDetailModal/ApplicationDetailModal.style");
const HiringProcess_style_1 = require("./HiringProcess.style");
const getDefaultApplicationGroups = () => ({
    new: [],
    preselection: [],
    interview: [],
    hired: [],
    rejected: [],
});
function transformApplicationsToGroups(applications) {
    return applications === null || applications === void 0 ? void 0 : applications.reduce((obj, app) => {
        obj[app.hiringProcessStage.name].push(app);
        return obj;
    }, getDefaultApplicationGroups());
}
function HiringProcess() {
    const [initialized, setInitialized] = react_1.default.useState(false);
    const [applications, setApplications] = react_1.default.useState(null);
    const [applicationDetail, setApplicationDetail] = react_1.default.useState(null);
    const [showFinishHiringProcessModal, setShowFinishHiringProcessModal] = react_1.default.useState(false);
    const [isSendMessageModalOpen, setIsSendMessageModalOpen] = react_1.default.useState(false);
    const [selectedApplications, setSelectedApplications] = react_1.default.useState([]);
    const [updateView, setUpdateView] = react_1.default.useState(false);
    const [offer, setOffer] = react_1.default.useState(null);
    const account = (0, account_context_1.useAccount)();
    // @ts-ignore
    const company = (0, react_redux_1.useSelector)(state => state.admin.company);
    const { offerId } = (0, react_router_dom_1.useParams)();
    const { myOffers } = (0, admin_context_1.useAdminContextValue)();
    const history = (0, react_router_dom_1.useHistory)();
    const intl = (0, react_intl_1.useIntl)();
    const isAccountVerified = react_1.default.useMemo(() => {
        return !!(account === null || account === void 0 ? void 0 : account.verified);
    }, [account === null || account === void 0 ? void 0 : account.verified]);
    const isHiringProcessActive = react_1.default.useMemo(() => {
        return Boolean(offer === null || offer === void 0 ? void 0 : offer.isHiringProcessActive);
    }, [offer === null || offer === void 0 ? void 0 : offer.isHiringProcessActive]);
    const isSendMessageDetailOpen = Boolean(applicationDetail);
    const applicationsToSendMessage = isSendMessageDetailOpen
        ? transformApplicationsToGroups([applicationDetail])
        : transformApplicationsToGroups(selectedApplications);
    const init = react_1.default.useCallback(async () => {
        if (!company) {
            return;
        }
        try {
            // we don't need drafts - drafts should not be published
            // therefore they should not have any applications
            const myOffersMerged = [...myOffers.active, ...myOffers.notActive];
            if (myOffersMerged.length === 0) {
                return;
            }
            const defaultOffer = myOffersMerged.find(o => o.id === Number(offerId)) || myOffersMerged[0];
            const { offerApplications, ...offerData } = await Api.Admin.getOfferApplications(defaultOffer.id);
            setApplications(offerApplications);
            setOffer(offerData);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
        }
        finally {
            setInitialized(true);
            setUpdateView(false);
        }
    }, [offerId, company, myOffers]);
    react_1.default.useEffect(() => {
        init();
    }, [init]);
    react_1.default.useEffect(() => {
        if (updateView) {
            init();
        }
    }, [updateView]);
    const { data: hiringProcessStages } = (0, useAppQuery_1.useAppQuery)([queries_1.Queries.getHiringProcessStages, offerId], async () => {
        const data = await Api.HiringProcess.getHiringProcessStages(Number(offerId) || offer.id);
        return data;
    }, { enabled: Boolean(Number(offerId) || (offer === null || offer === void 0 ? void 0 : offer.id)) });
    if (!initialized) {
        return ((0, jsx_runtime_1.jsx)(elements_1.Panel, { className: "flex-center", children: (0, jsx_runtime_1.jsx)(elements_1.Spinner, {}) }));
    }
    if (!offer || !offerId) {
        return ((0, jsx_runtime_1.jsx)(elements_1.Panel, { children: (0, jsx_runtime_1.jsxs)("div", { className: "flex-col flex-center", children: [(0, jsx_runtime_1.jsx)(HiringProcess_style_1.StyledNoteAlert, {}), (0, jsx_runtime_1.jsx)(HiringProcess_style_1.CentredHeading, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.hiring_process.missing_data" }) }), (0, jsx_runtime_1.jsx)(HiringProcess_style_1.CentredDiv, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.hiring_process.for_start" }) }), !isAccountVerified && ((0, jsx_runtime_1.jsx)("div", { className: "m-b-m text-center", children: (0, jsx_runtime_1.jsx)("p", { className: "m-b-none", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offers.verification_notice" }) }) })), (0, jsx_runtime_1.jsx)("div", { className: "flex-center", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { disabled: !isAccountVerified, 
                            // @ts-ignore
                            onClick: () => history.pushLocalized('/admin/pridat-ponuku'), "data-cy": "add-offer", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offers.add_offer" }) }) })] }) }));
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(elements_1.Panel, { children: [!isHiringProcessActive && ((0, jsx_runtime_1.jsx)(ApplicationDetailModal_style_1.StyledInfoAlert, { message: intl.formatMessage({
                            id: 'admin.hiring_process.this_offer_was_closed',
                        }), type: "info", showIcon: true })), (0, jsx_runtime_1.jsx)(HiringProcessColumns_1.HiringProcessColumns, { applications: applications, setApplications: setApplications, setApplicationDetail: setApplicationDetail, isHiringProcessActive: isHiringProcessActive, setShowFinishHiringProcessModal: setShowFinishHiringProcessModal, setIsSendMessageModalOpen: setIsSendMessageModalOpen, offer: offer, intl: intl, selectedApplications: selectedApplications, setSelectedApplications: setSelectedApplications, transformApplicationsToGroups: transformApplicationsToGroups, hiringProcessStages: hiringProcessStages }), (0, jsx_runtime_1.jsx)(ApplicationDetailModal_1.ApplicationDetailModal, { setApplicationDetail: setApplicationDetail, application: applicationDetail, applications: applications, setApplications: setApplications, isSendMessageModalOpen: isSendMessageModalOpen, setIsSendMessageModalOpen: setIsSendMessageModalOpen, intl: intl })] }), (0, jsx_runtime_1.jsx)(FinishHiringProcessModal_1.FinishHiringProcessModal, { visible: showFinishHiringProcessModal, setShowFinishHiringProcessModal: setShowFinishHiringProcessModal, offerId: Number(offerId) || offer.id, setUpdateView: setUpdateView, intl: intl, applications: applications, offerTitle: offer.title }), isSendMessageModalOpen && ((0, jsx_runtime_1.jsx)(HiringProcessColumnsSendMessageModal_1.HiringProcessColumnsSendMessageModal, { setApplications: (applicationSteps) => {
                    const appsWithInterview = Object.values(applicationSteps)
                        .reduce((acc, step) => acc.concat(step.applications), [])
                        .filter(app => app.interviewDate);
                    const newApps = (0, immer_1.default)(applications, draft => {
                        appsWithInterview.forEach(app => {
                            const appToUpdate = draft === null || draft === void 0 ? void 0 : draft.find(a => a.id === app.id);
                            appToUpdate.interview_date = app.interviewDate;
                            appToUpdate.interview_duration_minutes = app.interviewDurationMinutes;
                        });
                    });
                    setApplications(newApps);
                }, applications: applicationsToSendMessage, isOpen: isSendMessageModalOpen, onClose: () => setIsSendMessageModalOpen(false) }))] }));
}
